export { default as Tab } from "./tab";
export { default as TabPanel } from "./tabPanel";
export { default as Tabs } from "./tabs";
